import { Box, Chip, styled, Typography } from '@mui/material';

export const FormWrapper = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: theme.spacing(2),
  marginTop: theme.spacing(2),
  padding: `0 ${theme.spacing(0.5)} ${theme.spacing(0.5)}`,
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  gridColumn: '1 / -1',
  fontWeight: 600,
  textTransform: 'uppercase',
  color: theme.palette.text.secondary,
  marginTop: theme.spacing(2),
  borderBottom: `1px solid ${theme.palette.divider}`,
  paddingBottom: theme.spacing(0.5),
}));

export const BooleanWrapper = styled(Box)(({ theme }) => ({
  gridColumn: '1 / -1',
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: theme.spacing(2),
  marginTop: theme.spacing(1),
}));

export const FieldsValues = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gap: theme.spacing(1.25),
  marginTop: theme.spacing(1),
}));

export const StyledChip = styled(Chip)(({ theme }) => ({
  maxWidth: 'max-content',
  background: 'white',
  border: `1px solid ${theme.palette.secondary.light}`,
}));

export const ChipsWrapper = styled(Box)(({ theme }) => ({
  gridColumn: '1 / -1',
  display: 'flex',
  gap: theme.spacing(1),
  flexWrap: 'wrap',
  marginTop: theme.spacing(2),
}));

export const ParameterWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
});
